import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { RecipientsApi, type RecipientResponse } from '@shared/api';

const deleteRecipientEffect = createEffect((id: string) => RecipientsApi.deleteRecipient(id));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(deleteRecipientEffect.done, (current, values) => values.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(deleteRecipientEffect.pending, (_, data) => data)
  .on(deleteRecipientEffect.fail, () => false)
  .on(deleteRecipientEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(deleteRecipientEffect, () => null)
  // .on(deleteRecipientEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(deleteRecipientEffect.fail, () => 'Something went wrong while deleting Recipient. Please try again.')
  .on(deleteRecipientEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $deleteRecipientStore = {
  events: {
    deleteRecipient: deleteRecipientEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
